// src/components/legal/PrivacyContent.tsx
export function PrivacyContent() {
  return (
    <div className="space-y-5">
      <p>
        Esta Política descreve como a <strong>LDA — Libertação das Apostas</strong>, operada por
        <strong> 53.820.194 MARLON GUSTAVO DA SILVA RIBEIRO</strong> (CNPJ 53.820.194/0001-38), coleta, usa,
        compartilha e protege seus dados pessoais, em conformidade com a LGPD (Lei nº 13.709/2018).
      </p>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">1. Dados que Coletamos</h4>
        <ul className="list-disc space-y-1 pl-5">
          <li><strong>Fornecidos por você:</strong> nome, e-mail, telefone, dados de compra e mensagens enviadas.</li>
          <li><strong>Automáticos:</strong> IP, dispositivo, navegador, páginas acessadas, cookies e identificadores.</li>
          <li><strong>Transacionais:</strong> status de pagamento, produto adquirido e histórico de acesso.</li>
        </ul>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">2. Bases Legais</h4>
        <p>
          Consentimento; execução de contrato; cumprimento de obrigação legal; e legítimo interesse
          (por exemplo, aperfeiçoamento de serviço e prevenção a fraudes).
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">3. Finalidades</h4>
        <ul className="list-disc space-y-1 pl-5">
          <li>Criar/gerenciar sua conta e liberar acessos contratados.</li>
          <li>Atendimento, suporte e comunicações sobre sua jornada.</li>
          <li>Processar pagamentos e cumprir obrigações fiscais.</li>
          <li>Enviar conteúdos, atualizações e ofertas (com opção de descadastro).</li>
          <li>Segurança, prevenção a fraudes e melhoria de produto.</li>
        </ul>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">4. Compartilhamento</h4>
        <p>
          Podemos compartilhar dados com provedores de pagamento, hospedagem, e-mail/automação,
          suporte e analytics, sempre sob contrato e somente para as finalidades descritas.
          Não vendemos seus dados pessoais.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">5. Cookies</h4>
        <p>
          Usamos cookies para lembrar preferências, medir performance e personalizar conteúdo.
          Você pode ajustar no seu navegador; algumas funções podem ficar limitadas.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">6. Direitos do Titular</h4>
        <p>
          Você pode solicitar: confirmação de tratamento; acesso; correção; portabilidade;
          anonimização; eliminação; informação sobre compartilhamentos; e revogação de consentimento.
          Para exercer, escreva para{" "}
          <a className="text-cyan-300 underline" href="mailto:contato@libertacaodasapostas.com.br">
            contato@libertacaodasapostas.com.br
          </a>.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">7. Segurança e Retenção</h4>
        <p>
          Adotamos medidas técnicas e organizacionais compatíveis com o risco. Guardamos os dados
          pelo tempo necessário ao cumprimento das finalidades e obrigações legais/contratuais.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">8. Crianças e Adolescentes</h4>
        <p>
          Nossos serviços são voltados a maiores de 18 anos. Caso identifiquemos cadastro de menor,
          poderemos remover e eliminar dados conforme a legislação aplicável.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">9. Transferências Internacionais</h4>
        <p>
          Alguns fornecedores podem estar fora do Brasil. Nesses casos, adotamos salvaguardas
          contratuais e técnicas compatíveis com a LGPD.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">10. Atualizações</h4>
        <p>
          Esta Política pode ser atualizada. A versão vigente estará sempre publicada no site.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">11. Contato do Encarregado (DPO)</h4>
        <p>
          E-mail:{" "}
          <a className="text-cyan-300 underline" href="mailto:contato@libertacaodasapostas.com.br">
            contato@libertacaodasapostas.com.br
          </a>
        </p>
      </section>
    </div>
  );
}
